<template>
  <v-container
    fluid>
    <v-row
      justify="center">
      <v-col
        class="pt-4"

        cols="12"
        md="8">
        <v-select
          :items="subjects"
          :value="selectedSubject"
          @change="changeSubject"
          label="Select Subject"
        />
      </v-col>

      <v-col
        cols="12"
        md="8"
        v-if="approvedMediaPhoto.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No Uploads available to view.
        </v-alert>
      </v-col>

      <v-col
        class="pt-4"
        cols="12"
        md="8">
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="(mediaArr, term) in approvedMediaPhoto"
            :key="term"
          >
            <v-expansion-panel-header
              class="font-weight-bold subtitle-2"
              v-if="term.includes('Generic Uploads') && genericName!==''"> {{ genericName }}</v-expansion-panel-header>

            <v-expansion-panel-header
              class="font-weight-bold subtitle-2"
              v-else>{{ term }}</v-expansion-panel-header>

            <v-expansion-panel-content>

              <v-card-text
                v-for="(mediaDetails, termSlot) in mediaArr"
                :key="termSlot"
                class="pa-0 text-center font-weight-bold subtitle-2">
                {{ termSlot }}
                <v-card-text/>

                <p
                  class="text-left caption"
                  v-if="mediaDetails.comment !== undefined && mediaDetails.comment !== null && mediaDetails.comment !== ''">
                  {{ mediaDetails.comment }}
                </p>

                <v-card-text
                  v-for="(url, mediaIndex) in mediaDetails.media"
                  :key="mediaIndex"
                  class="pa-2 text-center">

                  <template v-if="mediaDetails.extensions">
                    <v-card
                      v-for="(tempExtensions, exIndex) in mediaDetails.extensions"
                      :key="exIndex">
                      <v-img
                        v-if="isImage(tempExtensions)"
                        contain
                        max-height="1080"
                        :src="url"/>
                      <v-btn
                        :href="url"
                        class="mt-3 mb-3"
                        target="_blank"
                        style="text-decoration: none;"
                        v-else>
                        <span>Open {{ getFileExtension(tempExtensions) }} <v-icon>fa-external-link-alt</v-icon></span>
                      </v-btn>
                    </v-card>
                  </template>

                  <v-divider/>
                </v-card-text>

                <v-card-text
                  v-if="mediaDetails.walts !== undefined"
                  class="p-0 text-sm-left caption subtitle-2 font-italic">

                  <p
                    v-for="(waltsAssigned, waltsIndex) in mediaDetails.walts"
                    :key="waltsIndex"
                    class="p-0 text-sm-left subtitle-2 font-italic">
                    {{ waltsAssigned }}

                  </p>

                </v-card-text>

                <v-divider/>

              </v-card-text>

            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-expansion-panels>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    subjects: ['ALL'],
    selectedSubject: 'ALL',
    approvedMediaPhoto: [],
    pupilPhotoToUse: '',
    skillDescriptArray: [],
    genericName: '',
    colors: [
      'indigo',
      'warning',
      'pink darken-2',
      'red lighten-1',
      'deep-purple accent-4'
    ],
    slides: [
      'First',
      'Second',
      'Third',
      'Fourth',
      'Fifth'
    ]
  }),

  computed: {
    pupilPhoto: function () { return this.$store.getters.pupilPhoto },
    pupilPreferredName: function () { return this.$store.getters.pupilPreferredName }
  },
  methods: {
    shouldHideControls: function (imagesArr) {
      return imagesArr.length <= 1
    },
    changeSubject: function (selection) {
      if (selection !== this.selectedSubject) {
        this.selectedSubject = selection

        this.$store.commit('loading', true)
        this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/spotlightV2/spotlightmyuploadV2/' + this.selectedSubject)
          .then(resp => {
            this.approvedMediaPhoto = resp.data.approvedMediaPhoto
            this.$store.commit('loading', false)
          })
      }
    },
    fixURLHttpPrefix: function (stringToFix) {
      return stringToFix.replace(/(http)?(s)?(:\/\/)?(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, 'http$2://$4')
    },
    isImage: function (stringToCheck) {
      var imageExtensions = ['.png', '.jpeg', '.jpg', '.gif']
      return imageExtensions.some(imgExt => stringToCheck.toLowerCase().includes(imgExt.toLowerCase()))
    },
    getFileExtension: function (string) {
      return string.split('.').pop()
    }
  },

  mounted: function () {
    this.$store.dispatch('logReadItems')
    this.pupilPhotoToUse = this.pupilPhoto
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // Get Subjects
      vm.$http.get('spotlightUploadSubjectsV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.subjects = vm.subjects.concat(resp.data.subjects)
          vm.genericName = resp.data.genericname
        })

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/spotlightV2/spotlightmyuploadV2')
        .then(resp => {
          vm.approvedMediaPhoto = resp.data.approvedMediaPhoto

          vm.$store.commit('loading', false)
          vm.$store.commit('toggle_dialog', true)
        })
    })
  }
}
</script>
